import React from 'react'
import Layout from '../../components/Layout/Layout'
import './Home.css'
import About from '../About/About'

export default function Home() {
  return (
    <Layout>
      <div className='home'>
        <div className='homeTitle'>
          <h1 className='name'><span className='crimson'>D</span>ele <span className='crimson'>A</span>kinfenwa</h1>
          <h2 className='sub' id='line1'>
            <span className='crimson'>S</span>oftware Engineer,
          </h2>
          <h2 className='sub' id='line2'>
            <span className='crimson'>A</span>nimator,
          </h2>
          <h2 className='sub' id='line3'>
            and <span className='crimson' >L</span>over of all the nerdy things
          </h2>

        </div>
        <p className='intro'>
          I collect skills the way some people collect vinyl: guitar, a second language, animation, software engineering, and most recently cloud infrastructure. My parents taught me to never stop learning, and these days that curiosity goes into designing and automating the systems that keep applications running reliably at scale.
        </p>
      </div >
    </Layout>
  )
}
